import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomToastrComponent } from './custom-toastr.component';

@NgModule({
    declarations: [CustomToastrComponent],
    imports: [CommonModule],
    exports: [CustomToastrComponent],
})
export class CustomToastrModule {}
